import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

const credentialTypes = ['api-username', 'api-password', 'api-key'] as const

export type sfpaCredType = (typeof credentialTypes)[number]
export const sfpaDocumentTypes = [
  'invoice',
  'proof-of-delivery',
] as const satisfies readonly DocumentType[]

export const sfpa: CarrierDef<sfpaCredType> = {
  name: 'Sunset Pacific Transportation',
  scac: 'sfpa',
  credentialTypes,
  engineLayers: ['rating', 'documents', 'tracking', 'pickup'],
  documentTypes: sfpaDocumentTypes,
}
